import { render } from "./AdminConfiguracion.vue?vue&type=template&id=4ccd83fe"
import script from "./AdminConfiguracion.vue?vue&type=script&lang=js"
export * from "./AdminConfiguracion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__